import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SaveLocaleChoiceResponse extends BackendResponse {}

export interface SaveLocaleChoiceParameters extends NextApiParams {
  locale: string;
}

export const saveLocaleChoice = withNextApi<
  SaveLocaleChoiceResponse,
  SaveLocaleChoiceParameters
>("/auth/SaveLocaleChoice");
